
// src/web/components/group-sorting-page.jsx

import React from 'react'
import connect from '../../connects/group-sorting-panel.js'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Card,
  CardText,
} from 'react-toolbox/lib/card'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import theme from './themes/flat-card.css'
import sortableTheme from './themes/sortable.css'
import groupSortingPageTheme from './themes/group-sorting-page.css'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc'
import { Color } from 'highcharts'
import Tooltip from 'react-toolbox/lib/tooltip'
import leftSidebarGroupListItemTheme from "./themes/left-sidebar-group-list-item.css";
import logoPng from "../images/logo.png";

const SortableListItem = SortableElement(ListItem)
const TooltipIconButton = Tooltip(IconButton)

class GroupsList extends React.Component {
  state = {}

  render() {
    const {
      t,
      groups,
      MemberGroups,
      divisions,
      menuItems,
      flashNewFreeGroupId,
      expandedDivisionSort,
      sorting,
      selectSorting,
      setFreeMenu,
      setNotFreeMenu,
      expandDivisionSort,
      collapseDivisionSort,
      expandDivisionSortNotSetGroup,
      canExpandDivSortNotSetGroup,
      sortingMenu
    } = this.props

    const groupsOnSet = MemberGroups ? MemberGroups.filter(item => !item.is_free_group) : []
    const groupsNotSet = MemberGroups ? MemberGroups.filter(g => g.is_free_group && (g.is_member || g.favorite)) : []
    const totalDivision = menuItems.filter(function (menuItem) {
      const subGroupsId = menuItems.filter(menu => menu.type == 'group' && menu.parent_id == menuItem.item_id).map(menu => menu.item_id)
      const hasSubMenu = groupsOnSet.find(group => subGroupsId.includes(group.group_id) )
      return menuItem.type == 'division' && hasSubMenu
    }).length
    return(
      <div style={{ cursor: sorting && 'move'}}>
        <FontIcon value='info' style={{ verticalAlign: 'bottom',marginLeft: 25 }}/>
        <span style={{ marginLeft: 20 }}>{t('label:ドラッグして並べ替え')}</span>
        <List>
        {_.map(menuItems, (menuItem, i)=> {
          const menuExtra = menuItem.type == 'division'
            ? divisions.find(d => d.division_id == menuItem.item_id) : MemberGroups.find(g => g.group_id == menuItem.item_id && !g.is_free_group)
          const subGroupsId = menuItems.filter(menu => menu.type == 'group' && menu.parent_id == menuItem.item_id).map(menu => menu.item_id)
          const hasSubMenu = MemberGroups.find(group => subGroupsId.includes(group.group_id) )

          if (menuItem.type == 'division' && !hasSubMenu) return null
          if (menuItem.type == 'group' && !expandedDivisionSort.includes(menuItem.parent_id)) return null

          let rightAction
          if(menuItem.type == 'division' && !expandedDivisionSort.includes(menuItem.item_id))
            rightAction = (<IconButton key="expand_sub_groups" icon="expand_more" onClick={()=> expandDivisionSort(menuItem.item_id)} />)
          if(menuItem.type == 'division' && expandedDivisionSort.includes(menuItem.item_id))
            rightAction = (<IconButton key="collapse_sub_groups" icon="expand_less" onClick={()=> collapseDivisionSort(menuItem.item_id)} />)
          let isSortable = true
          if (sortingMenu && sortingMenu.type != menuItem.type)
            isSortable = false
          if (sortingMenu && sortingMenu.type == 'group' && sortingMenu.parent_id != menuItem.parent_id)
            isSortable = false

          return menuExtra && (<SortableListItem key={menuItem.position} selectable={false} ripple={false} index={menuItem.position}
                theme={groupSortingPageTheme}
                className={menuExtra.access_type
                  + ' ' + (menuItem.type == 'division' ? '' : 'indent')
                  + ' ' + (isSortable ? '' : 'disabled')}
                disabled={!sorting}
                avatar={menuExtra.icon_image.thumb_url}
                caption={menuExtra.name}
                rightActions={[rightAction]}
            />)
        })}
          {totalDivision > 0 && groupsNotSet.length > 0 && (<ListItem theme={leftSidebarGroupListItemTheme}
                     key={'division_group_not_set'}
                     caption={this.props.t('label:セクションなし')}
                     avatar={logoPng}
                     style={{height:5, width: 5, backgroundColor: '#000', borderRadius: 20}}
                     className={(!sortingMenu ? '' : 'disabled')}
                     rightActions={[
                       <IconButton
                           key={!canExpandDivSortNotSetGroup ? "expand_sub_groups" : "collapse_sub_groups"}
                           icon={!canExpandDivSortNotSetGroup ? "expand_more" : "expand_less"}
                           onClick={expandDivisionSortNotSetGroup}
                       />]}
          />)}
        { (totalDivision == 0 ? true: canExpandDivSortNotSetGroup ) && groupsNotSet && _.map(menuItems, (menuItem, i)=> {
            const menuExtra = groupsNotSet.find(g => g.group_id == menuItem.item_id && menuItem.is_free_group)
            return menuExtra && (<SortableListItem key={menuItem.position} selectable={false} ripple={false} index={menuItem.position}
              theme={groupSortingPageTheme}
              className={menuExtra.access_type
                  + ' ' + (totalDivision > 0 ? ('indent') : '')
                  + ' ' + (sortingMenu && (sortingMenu.type != 'group' || !sortingMenu.is_free_group) ? 'disabled' : '')}
              disabled={!sorting}
              avatar={menuExtra.icon_image.thumb_url}
              caption={menuExtra.name}
                />)
        })}
        </List>
      </div>
    )
  }
}

const SortableGroupsList = SortableContainer(GroupsList)

class SortGroupsPage extends React.Component {
  state = { sorting: true, selectSorting: false }
  onSortEnd = (index)=> {
    document.body.style.userSelect = '' // Restore default behavior
    this.props.sortMenu(index.oldIndex, index.newIndex)
    this.props.setSortingMenuPosition(null)
    this.setState({ selectSorting: !this.state.selectSorting })
  }
  onSortStart  = (index)=> {
    document.body.style.userSelect = 'none' // Prevent text selection
    this.props.setSortingMenuPosition(index.index)
    this.setState({ selectSorting: !this.state.selectSorting })
  }
  render() {
    const {
      t,
      menuItems,
    } = this.props

    return(
      <Card theme={theme}>
        {menuItems &&
        <CardText>
          <SortableGroupsList {...this.props}
            onSortStart={this.onSortStart}
            onSortEnd={this.onSortEnd}
            helperClass={sortableTheme.sortable}
            sorting={this.state.sorting}
            selectSorting={this.state.selectSorting} />
        </CardText> ||
        <List selectable>
          <ListItem caption={t('label:セクション/グループはありません')} />
        </List>
        }
      </Card>
    )
  }
}

export const RawSortGroupsPage = SortGroupsPage
export default connect(SortGroupsPage)



// WEBPACK FOOTER //
// ./src/web/components/group-sorting-page.jsx